<mat-card style="height: 600px;overflow: hidden;">
  <form #loginForm="ngForm">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <h3 style="padding-left:5px">{{ 'innovacioDialog.titol' | translate }}</h3>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="desar()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
      </div>  
    </mat-toolbar>
<span style="width:100%">&nbsp;</span>
<mat-tab-group style="float:left;clear:both;height: 600px;width: 700px">
  <mat-tab label="{{ 'innovacioDialog.tabInnovador' | translate }}" style="padding-bottom:20px;height: 600px">
    <mat-card-content style="float:left;clear:none;width:100%;padding-top:20px">
      <mat-form-field style="width:250px">
        <mat-select style="width:250px" [(ngModel)]="editInnovacioData.tipus" placeholder="{{ 'propostaMi.camps.tipus' | translate }}" name="tipus">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus.text" [selected]="tipus.text === editInnovacioData.tipus">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:none;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editInnovacioData.innova_metodologic" placeholder="{{ 'innovacioDialog.innovacioMetodologica' | translate }}" name="innova_metodologic">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let tipus of possibleTipusInnoMet" [value]="tipus.text" [selected]="tipus.text === editInnovacioData.innova_metodologic">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:none;width:250px">
        <mat-select style="width:250px" [(ngModel)]="editInnovacioData.innova_dev_informatic" placeholder="{{ 'innovacioDialog.innovacioDevInformatic' | translate }}" name="innova_dev_informatic">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let tipus of possibleDevInf" [value]="tipus.text" [selected]="tipus.text === editInnovacioData.innova_dev_informatic">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:120px">
       <input matInput style="width:70px"
        placeholder="{{ 'innovacioDialog.percentDevMetodologic' | translate }}" name="percent_dev_metodologic" type="string"
        [(ngModel)]="editInnovacioData.percent_dev_metodologic" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="float:left;clear:none;width:150px">
       <input matInput style="width:30px"
        placeholder="{{ 'innovacioDialog.percentDevInformatic' | translate }}" name="percent_dev_informatic" type="string"
        [(ngModel)]="editInnovacioData.percent_dev_informatic" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:150px">
       <input matInput style="width:30px"
        placeholder="{{ 'innovacioDialog.percentFinanIntern' | translate }}" name="percent_finan_intern" type="string"
        [(ngModel)]="editInnovacioData.percent_finan_intern" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:100%">
       <textarea matInput style="width:100%"
        placeholder="{{ 'innovacioDialog.obsInnovacioMetodologica' | translate }}" name="obs_innova_metodologic" type="obs_innova_metodologic"
        [(ngModel)]="editInnovacioData.obs_innova_metodologic" ngDefaultControl></textarea>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:100%">
       <textarea matInput style="width:100%"
        placeholder="{{ 'innovacioDialog.obsInnovacioInformatica' | translate }}" name="obs_innova_dev_informatic" type="obs_innova_dev_informatic"
        [(ngModel)]="editInnovacioData.obs_innova_dev_informatic" ngDefaultControl></textarea>
      </mat-form-field>
      <div style="float:left;clear:left;color:red;font-style:italic"><sup>*</sup> {{ 'innovacioDialog.avisEsborrar' | translate }}</div>
      <div style="height:50px">&nbsp;</div>
    </mat-card-content>
    </mat-tab>
    <mat-tab label="{{ 'innovacioDialog.tabInformatic' | translate }}" style="height: 650px"> 
      <mat-card-content style="float:left;clear:none;width:100%;padding-top:20px">
      <table>
        <tr>
          <th style="width:250px"> {{ 'innovacioDialog.fasesTitol' | translate }}</th>
          <th style="text-align: left;width:70px">{{ 'innovacioDialog.colTotal' | translate }}</th>
          <th style="text-align: left;width:70px">{{ 'innovacioDialog.colInnovacio' | translate }}</th>
        </tr>
        <tr>
          <td style="width:250px">{{ 'innovacioDialog.faseAnalisiNecessitats' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t1_1" type="string"
                [(ngModel)]="editSoftData.t1_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t1_2" type="string"
                [(ngModel)]="editSoftData.t1_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{ 'innovacioDialog.faseNecessitatsUsuari' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t2_1" type="string"
                [(ngModel)]="editSoftData.t2_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t2_2" type="string"
                [(ngModel)]="editSoftData.t2_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
         <tr>
          <td>{{ 'innovacioDialog.faseEstudiMercat' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t3_1" type="string"
                [(ngModel)]="editSoftData.t3_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t3_2" type="string"
                [(ngModel)]="editSoftData.t3_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{ 'innovacioDialog.faseDisseny' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t4_1" type="string"
                [(ngModel)]="editSoftData.t4_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t4_2" type="string"
                [(ngModel)]="editSoftData.t4_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{ 'innovacioDialog.faseDesenvolupament' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t5_1" type="string"
                [(ngModel)]="editSoftData.t5_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t5_2" type="string"
                [(ngModel)]="editSoftData.t5_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{ 'innovacioDialog.faseTesteig' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t6_1" type="string"
                [(ngModel)]="editSoftData.t6_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t6_2" type="string"
                [(ngModel)]="editSoftData.t6_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{ 'innovacioDialog.faseImplementacio' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t7_1" type="string"
                [(ngModel)]="editSoftData.t7_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t7_2" type="string"
                [(ngModel)]="editSoftData.t7_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{ 'innovacioDialog.faseDocumentacio' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t8_1" type="string"
                [(ngModel)]="editSoftData.t8_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t8_2" type="string"
                [(ngModel)]="editSoftData.t8_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>{{ 'innovacioDialog.faseFormacio' | translate }}</td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colTotal' | translate }}" name="t9_1" type="string"
                [(ngModel)]="editSoftData.t9_1" ngDefaultControl
                />
              </mat-form-field>
          </td>
          <td>
              <mat-form-field class="filasoft">
                <input matInput style="width:70px"
                placeholder="{{ 'innovacioDialog.colInnovacio' | translate }}" name="t9_2" type="string"
                [(ngModel)]="editSoftData.t9_2" ngDefaultControl
                />
              </mat-form-field>
          </td>
        </tr>
      </table>
      <span style="float:left;clear:left;width:100%;padding-top:20px;padding-bottom:20px">{{ 'innovacioDialog.tipusDevInformatic' | translate }}</span>
      <mat-form-field style="float:left;clear:left;width:120px">
        <mat-select style="width:120px" [(ngModel)]="editSoftData.front_end" placeholder="{{ 'innovacioDialog.frontEnd' | translate }}" name="front_end">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let tipus of possibleFrontEnd" [value]="tipus.value" [selected]="tipus.value === editSoftData.front_end">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:none;width:120px">
       <mat-select style="width:120px" [(ngModel)]="editSoftData.back_end" placeholder="{{ 'innovacioDialog.backEnd' | translate }}" name="back_end">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let tipus of possibleBackEnd" [value]="tipus.value" [selected]="tipus.value === editSoftData.back_end">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:none;width:120px">
       <mat-select style="width:120px" [(ngModel)]="editSoftData.desktop" placeholder="{{ 'innovacioDialog.desktop' | translate }}" name="desktop">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let tipus of possibleDesktop" [value]="tipus.value" [selected]="tipus.value === editSoftData.desktop">{{tipus.text}}</mat-option>
        </mat-select>
      </mat-form-field>
            <mat-form-field style="float:left;clear:left;width:100%">
       <textarea matInput style="width:100%"
        placeholder="{{ 'facturacio.taula.colObservacions' | translate }}" name="observacions" type="observacions"
        [(ngModel)]="editSoftData.observacions" ngDefaultControl></textarea>
      </mat-form-field>
      <div style="float:left;clear:left;color:red;font-style:italic;width:100%"><sup>*</sup> {{ 'innovacioDialog.avisEsborrar' | translate }}</div>
      <div style="float:left;clear:left;height:190px;width:100%">&nbsp;</div>
      </mat-card-content>
    </mat-tab>
   </mat-tab-group>
  </form>
</mat-card>
